module.exports = __webpack_public_path__ + "img/img-1.b2e5a48.jpg";